var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-checkbox',{attrs:{"label":_vm.label,"value":_vm.code}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }